// Copyright (c) 2016 Deere & Company

import FailurePanelContainer from './failure-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    application: state.claims.battery.application,
    claim: state.claims.battery.claim,
    failureModes: state.claims.battery.failureModes,
    formValidation: state.claims.battery.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.battery.isEditable,
    isValidClaim: state.claims.battery.isValidClaim,
    testResultsCode: state.claims.battery.claim.testResultsCode
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FailurePanelContainer);



// WEBPACK FOOTER //
// ./src/claim/battery/components/failure-panel/index.js